import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorIcon from '../../../Icons/24x24/Error';
import { CommentContext } from '../CommentContext';
import { canPeek } from '../../utils';
import s from './SpamCommentBody.scss';
var SpamCommentBody = function () {
    var t = useTranslation().t;
    var _a = useContext(CommentContext), setPeeking = _a.setPeeking, comment = _a.comment;
    return (React.createElement("div", { "data-commentid": comment.commentId, "data-typeid": comment.typeId, "data-itemid": comment.itemId },
        React.createElement("button", { className: s['spam'], onClick: canPeek(comment) ? function () { return setPeeking(true); } : undefined },
            React.createElement("span", { className: s['spam-text'] },
                React.createElement(ErrorIcon, { className: s['hidden-icon'] }),
                t('comment.visibility.spam')))));
};
SpamCommentBody.displayName = 'SpamCommentBody';
export default SpamCommentBody;
//# sourceMappingURL=SpamCommentBody.js.map